import type { ReactNode } from "react";
import { CoreProviders } from "@/providers/CoreProviders";
import { DevelopmentProviders } from "@/providers/DevelopmentProviders";
import { FeatureProviders } from "@/providers/FeatureProviders";

/**
 * Provider 3 層を合成するアプリ全体のエントリポイント。
 *  - CoreProviders         : テーマ / CSS リセット等の必須基盤
 *  - FeatureProviders      : Feature 横断の Context 配布
 *  - DevelopmentProviders  : 開発時のみ有効化（DevTools / デバッグオーバーレイ等）
 */
export function AppProviders({ children }: { children: ReactNode }) {
  const tree = (
    <CoreProviders>
      <FeatureProviders>{children}</FeatureProviders>
    </CoreProviders>
  );
  return import.meta.env.DEV ? <DevelopmentProviders>{tree}</DevelopmentProviders> : tree;
}
